import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import '../assets/css/navbar.css';

export default function Navbar2(props) {
    const [options, setoptions] = useState(false)
    return (
        <div>
            <div className="navbar2" style={{ backgroundColor: 'black' }}>
                <div className="menu" >
                    <div className="hamburger-menu" onClick={() => setoptions(!options)}>
                        <div className="bar" ></div>
                    </div>
                </div>
            </div>
            <div className={options ? "mobile-menu  active" : "mobile-menu "}>
                <ul className={options ? "active" : ""}>
                <li onClick={() => setoptions(!options)}><NavLink exact to="/aurora" data-after='Aurora'>Aurora</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/sociopreneurs" data-after='Sociopreneurs'>Sociopreneurs</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/tamasha" data-after='Tamasha' >Tamasha</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/bazinga" data-after='Bazinga' >Bazinga</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/404_resolved" data-after='404 Resolved' >404 Resolved</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/all_rise" data-after='All Rise' >All Rise</NavLink></li>
                    <li onClick={() => setoptions(!options)}><NavLink exact to="/ingenious_geeks" data-after='Ingenious' >Ingenious Geeks</NavLink></li>
                </ul>
            </div>
        </div>
    )
}
